var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPackage3NuSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v30H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.548 9.045h7.379v14.454h-7.379z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.879 6.5h6.15v16.999h-6.15zM24.489 11.688h5.852v11.811h-5.852zM5.105 13.452h6.662v10.047H5.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 9.721h4.865v13.778H23.4zM3.831 12.25h3.587V23.5H3.831zM31.126 14.528h4.556V23.5h-4.556z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.185 16.972H38.5V23.5h-3.315zM1.5 16.972h3.315V23.5H1.5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M8.852 16.914h22.296v6.577H8.852z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9C4B9",
    d: "M8.66 22.722h22.68v1H8.66z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M31.136 15.72H8.864l-.397 1.219h23.065zM24.296 17.632h1.038v1.825h-1.038z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M25.333 19.458h-1.036l-.06.453h1.156z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.06V1.39L1.098.384z",
    transform: "translate(24.236 17.632)"
  }), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M25.74 17.632h1.038v1.825H25.74z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M26.777 19.458h-1.036l-.06.453h1.156z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.097 1.825H.06V1.39L1.097.384z",
    transform: "translate(25.68 17.632)"
  })), /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M27.65 17.632h1.039v1.825H27.65z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M28.687 19.458h-1.036l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.06V1.39L1.098.384z",
    transform: "translate(27.59 17.632)"
  }), /*#__PURE__*/React.createElement("g", null, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M29.094 17.632h1.038v1.825h-1.038z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M30.13 19.458h-1.036l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.06V1.39L1.098.384z",
    transform: "translate(29.034 17.632)"
  }))), /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M24.296 20.214h1.038v1.825h-1.038z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M25.333 22.04h-1.036l-.06.453h1.156z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.06V1.39L1.098.384z",
    transform: "translate(24.236 20.214)"
  }), /*#__PURE__*/React.createElement("g", null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M25.74 20.214h1.038v1.825H25.74z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M26.777 22.04h-1.036l-.06.453h1.156z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.097 1.825H.06V1.39L1.097.384z",
    transform: "translate(25.68 20.214)"
  })), /*#__PURE__*/React.createElement("g", null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M27.65 20.214h1.039v1.825H27.65z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M28.687 22.04h-1.036l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.06V1.39L1.098.384z",
    transform: "translate(27.59 20.214)"
  }), /*#__PURE__*/React.createElement("g", null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M29.094 20.214h1.038v1.825h-1.038z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M30.13 22.04h-1.036l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.06V1.39L1.098.384z",
    transform: "translate(29.034 20.214)"
  })))), /*#__PURE__*/React.createElement("g", null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M9.868 17.632h1.038v1.825H9.868z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M10.905 19.458H9.868l-.06.453h1.158z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.059V1.39L1.098.384z",
    transform: "translate(9.809 17.632)"
  }), /*#__PURE__*/React.createElement("g", null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M11.311 17.632h1.038v1.825h-1.038z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M12.349 19.458h-1.037l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.059V1.39L1.098.384z",
    transform: "translate(11.252 17.632)"
  })), /*#__PURE__*/React.createElement("g", null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M13.222 17.632h1.038v1.825h-1.038z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M14.26 19.458h-1.038l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.06V1.39L1.098.384z",
    transform: "translate(13.162 17.632)"
  }), /*#__PURE__*/React.createElement("g", null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M14.666 17.632h1.038v1.825h-1.038z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M15.703 19.458h-1.037l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.06V1.39L1.098.384z",
    transform: "translate(14.606 17.632)"
  }))), /*#__PURE__*/React.createElement("g", null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M9.868 20.214h1.038v1.825H9.868z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M10.905 22.04H9.868l-.06.453h1.158z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.059V1.39L1.098.384z",
    transform: "translate(9.809 20.214)"
  }), /*#__PURE__*/React.createElement("g", null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M11.311 20.214h1.038v1.825h-1.038z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M12.349 22.04h-1.037l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.059V1.39L1.098.384z",
    transform: "translate(11.252 20.214)"
  })), /*#__PURE__*/React.createElement("g", null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M13.222 20.214h1.038v1.825h-1.038z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M14.26 22.04h-1.038l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.06V1.39L1.098.384z",
    transform: "translate(13.162 20.214)"
  }), /*#__PURE__*/React.createElement("g", null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M14.666 20.214h1.038v1.825h-1.038z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M15.703 22.04h-1.037l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.098 1.825H.06V1.39L1.098.384z",
    transform: "translate(14.606 20.214)"
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C5",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M.385 1.222h22.296v1H.385z",
    transform: "translate(8.467 15.72)"
  }), /*#__PURE__*/React.createElement("g", null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M15.797 14.926 20 11.486l4.202 3.44z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M23.46 23.496h-6.92v-8.571L20 12.079l3.46 2.846z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M17.501 19.664h4.997v3.833h-4.997z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.704 8.216v3.795h.23V8.352H6.47v3.659h.231V8.216z",
    transform: "translate(15.797 11.486)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M16.348 19.122h7.304v1h-7.304z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.389 21.36c-.027-.545-.638-.98-1.39-.98-.75 0-1.362.435-1.389.98v2.134h2.78l-.001-2.134z",
    fill: "#9A5238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.391 3.114h1.39L2.78.981C2.753.436 2.142 0 1.39 0v3.114z",
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(18.61 20.38)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.769 14.18a.771.771 0 0 1-.769.774.771.771 0 0 1-.768-.773c0-.427.344-.774.768-.774.425 0 .769.347.769.774z",
    fill: "#BD8F7E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20.606 14.18c0 .338-.271.61-.606.61a.607.607 0 0 1-.605-.61c0-.336.27-.609.605-.609.335 0 .606.273.606.61z",
    fill: "#F9DFD1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M17.314 15.778h1.038V18.3h-1.038z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M18.352 18.301h-1.037l-.06.453h1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.097 2.521H.06v-.435L1.097 1.08z",
    transform: "translate(17.255 15.778)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M18.758 15.778h1.038V18.3h-1.038z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M19.796 18.301h-1.037l-.06.453h1.156z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.097 2.521H.06v-.435L1.097 1.08z",
    transform: "translate(18.699 15.778)"
  }), /*#__PURE__*/React.createElement("g", null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M20.202 15.778h1.038V18.3h-1.038z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M21.24 18.301h-1.037l-.06.453h1.156z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.097 2.521H.06v-.435L1.097 1.08z",
    transform: "translate(20.143 15.778)"
  })), /*#__PURE__*/React.createElement("g", null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M21.646 15.778h1.038V18.3h-1.038z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M22.683 18.301h-1.037l-.06.453h1.157z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M21.648 16.102h1.037l.06-.453h-1.157zM20.204 16.102h1.037l.06-.453h-1.157zM18.76 16.102h1.037l.06-.453H18.7zM17.317 16.102h1.037l.06-.453h-1.157z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M5.427 2.65H4.389v-.435L5.427 1.21z",
    transform: "translate(17.257 15.65)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M.744 3.664 4.202.817l3.459 2.847.001-.228L4.202.59.743 3.436z",
    transform: "translate(15.797 11.486)"
  }), /*#__PURE__*/React.createElement("g", null, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M22.409 22.424h1.153v1.072h-1.153zM22.412 19.706h1.153v1h-1.153z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h1.153v1H0z",
    transform: "translate(22.412 19.706)"
  }), /*#__PURE__*/React.createElement("g", null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M16.434 22.424h1.153v1.072h-1.153zM16.438 19.706h1.153v1h-1.153z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h1.153v1H0z",
    transform: "translate(16.438 19.706)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M14.62 10.546h1V23.5h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.976 11.834c-.783.537-1.567-.536-2.35 0v-1.341c.783-.537 1.567.536 2.35 0v1.341z",
    fill: "#F6C760"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6.413 21.975-.112-.051c-.067.148-.258.487-.476.61-.06.024-.079-.045-.083-.097v-.574h-.221v.578c-.005.054-.026.123-.094.087-.214-.129-.4-.458-.465-.604l-.112.05c.011.026.242.536.566.688.072.037.097.148.105.225v.613h.221v-.608c.008-.078.032-.193.107-.229h-.002c.324-.152.554-.662.565-.687v-.001z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.804 21.09a.631.631 0 0 0-.624-.72l-.01.001a.63.63 0 0 0-1.078 0h-.01a.631.631 0 0 0-.624.72.635.635 0 0 0 .45 1.076.627.627 0 0 0 .469-.211.623.623 0 0 0 .508 0 .631.631 0 0 0 1.098-.423.632.632 0 0 0-.179-.442z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.354 22.043a.629.629 0 0 1-.469-.21.623.623 0 0 1-.508 0 .63.63 0 0 1-1.095-.361.631.631 0 0 0 .626.696.627.627 0 0 0 .469-.212.623.623 0 0 0 .508 0 .631.631 0 0 0 1.095-.485.63.63 0 0 1-.626.572z",
    fill: "#528C10"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.094 21.314-.149-.067c-.087.196-.34.645-.63.808-.08.032-.104-.06-.11-.128v-.761h-.293v.766c-.006.071-.034.163-.124.114-.283-.17-.53-.608-.615-.8l-.149.067c.015.033.32.709.75.91.097.05.128.196.139.299v.976h.293v-.97c.01-.104.042-.256.142-.304h-.003c.43-.202.735-.878.75-.91h-.001z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.613 20.142a.837.837 0 0 0-.826-.953h-.015a.833.833 0 0 0-1.427 0h-.015a.837.837 0 0 0-.826.953.84.84 0 0 0 .597 1.426.832.832 0 0 0 .622-.279.825.825 0 0 0 .673 0 .83.83 0 0 0 .621.28c.46 0 .834-.376.834-.84a.84.84 0 0 0-.237-.587h-.001z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.016 21.404a.832.832 0 0 1-.622-.279.825.825 0 0 1-.673 0 .83.83 0 0 1-.621.28.836.836 0 0 1-.83-.759.837.837 0 0 0 .83.922.832.832 0 0 0 .622-.279.825.825 0 0 0 .673 0 .83.83 0 0 0 .621.28.837.837 0 0 0 .83-.923.837.837 0 0 1-.829.758h-.001z",
    fill: "#528C10"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.94 21.075 8.774 21c-.098.219-.38.72-.703.902-.09.035-.116-.067-.121-.143v-.848h-.328v.854c-.006.08-.038.182-.138.128-.316-.19-.59-.677-.686-.892l-.166.075c.017.037.357.79.836 1.015.107.055.143.218.154.332V23.5h.328v-1.07c.01-.116.046-.285.158-.34h-.004c.48-.224.82-.977.836-1.015z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.518 19.77a.933.933 0 0 0-.921-1.063h-.015a.927.927 0 0 0-1.591 0h-.016a.933.933 0 0 0-.921 1.062.935.935 0 0 0-.265.654c0 .516.417.935.93.935.275 0 .522-.12.692-.31a.924.924 0 0 0 .75 0c.171.19.418.31.693.31a.936.936 0 0 0 .665-1.59v.001z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.853 21.175a.926.926 0 0 1-.692-.311.924.924 0 0 1-.75 0 .925.925 0 0 1-.693.31.933.933 0 0 1-.926-.844.933.933 0 0 0 .925 1.027c.275 0 .523-.12.693-.31a.924.924 0 0 0 .75 0c.171.19.418.31.693.31a.933.933 0 0 0 .926-1.027.933.933 0 0 1-.926.845z",
    fill: "#528C10"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPackage3NuSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/package-3nu-small.f872110c5c6c7b8e008bf24b90ff3fa5.svg";